// components/common/EvaluateModal.jsx
import { useState, useEffect } from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";

export default function EvaluateModal({
  show,
  onClose,
  onSubmit,
  loading,
  message,        // نص الرسالة
  messageType,    // "success" أو "error"
}) {
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");

  // Reset form when modal closes
  useEffect(() => {
    if (!show) {
      setRating(0);
      setComment("");
    }
  }, [show]);

  const handleStarClick = (value) => {
    if (!loading) setRating(value);
  };

  const handleSubmit = () => {
    if (!loading) {
      onSubmit({ rating, comment });
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Evaluate Activity</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {/* رسالة الخطأ أو النجاح */}
        {message && (
          <div
            style={{
              marginBottom: "1rem",
              color: messageType === "error" ? "red" : "green",
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            {message}
          </div>
        )}

        {/* تقييم النجوم */}
        <div className="d-flex justify-content-center mb-3">
          {[1, 2, 3, 4, 5].map((star) => (
            <span
              key={star}
              style={{
                fontSize: "2rem",
                cursor: loading ? "not-allowed" : "pointer",
                color: star <= rating ? "#ffc107" : "#e4e5e9",
              }}
              onClick={() => handleStarClick(star)}
            >
              ★
            </span>
          ))}
        </div>

        {/* كومنت */}
        <Form>
          <Form.Group>
            <Form.Label>Comment</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              placeholder="Write your feedback here..."
              disabled={loading}
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose} disabled={loading}>
          Cancel
        </Button>

        <Button variant="success" onClick={handleSubmit} disabled={loading}>
          {loading ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />{" "}
              Submitting...
            </>
          ) : (
            "Submit"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
